<app-header (found)="handleResults($event)"></app-header>
<div id="main-wrapper">
  <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <div id="mainContainerDiv" class="main-background topSpace providerDataPage main-container">
    <div class="container-fluid topMargin" style="padding: 0;">
      <div class="row">
        <app-search-results [resultGridList]="data"></app-search-results>
        <div class="row col-md-12">
          <div class="heading">
            <h4>Provider Data Management </h4>
          </div>
        </div>
        <div class="pageheading p-0">
          <div class="clearfix providerDataManagementTab">
            <ul class="nav nav-tabs">
              <li class="nav-item "><button (click)="changeOldPDM()" data-bs-toggle="tab" class="nav-link active">Provider Outreach Response</button></li>
              <li class=" nav-item"><button (click)="changeNewPDM()" data-bs-toggle="tab" class="nav-link">Self Update</button></li>
            </ul>
          </div>
        </div>
      </div>
      @if (NewPDM) {
        <div class="row providerDetails">
          <form [formGroup]="dataUpdateForm" (ngSubmit)="submitForm(dataUpdateForm.controls)" autocomplete="off">
            <div class="col-md-12">
              <div>
                <h2>Provider Details</h2> <br>
                <div class="row col-md-12" style="margin-top:20px">
                  <div class="col-md-4">
                    <label><span class="red-star">*</span>Select provider(s)</label>
                    <select formControlName="provierIdFormControl" required class="form-select"
                      [(ngModel)]="selectedProviderId">
                      <option value="" disabled>Select</option>
                      @for (enquiry of provierIdOptions; track enquiry) {
                        <option [ngValue]="enquiry">{{enquiry.value}}</option>
                      }
                    </select>
                    @if (submitted && dataUpdateForm.controls.provierIdFormControl.invalid) {
                      <div
                        class="red-star">
                        @if (dataUpdateForm.controls.provierIdFormControl.errors.required) {
                          <div>
                            PCP is required**
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-md-4">
                    <label>Is provider planning to term?</label>
                    <select formControlName="planTermFormControl" type="text" class="form-select"
                      (change)="onSelectionChange($event)">
                      <option value="" selected>Select</option>
                      <option>Yes</option>
                      <option>No</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label>Term date</label>
                    <input type="date" formControlName="termDateFormControl" class="form-control datePadding" [disabled]="isTermDateDisabled">
                    @if (submitted && dataUpdateForm.controls.termDateFormControl.invalid) {
                      <div class="red-star">
                        @if (dataUpdateForm.controls.termDateFormControl.errors.required) {
                          <div>
                            Term date is required**
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="row col-md-12" style="margin-top:20px">
                  <div class="col-md-4">
                    <label>Address effective date</label>
                    <input type="date" formControlName="effectiveDateFormControl" class="form-control datePadding">
                  </div>
                  <div class="col-md-4">
                    <label><span class="red-star">*</span>Is panel close/open</label>
                    <select formControlName="panelStatusFormControl" class="form-select" required>
                      <option value="" disabled>Select</option>
                      <option value="Open">Open</option>
                      <option value="Closed">Closed</option>
                    </select>
                    @if (submitted && dataUpdateForm.controls.panelStatusFormControl.invalid) {
                      <div
                        class="red-star">
                        @if (dataUpdateForm.controls.panelStatusFormControl.errors.required) {
                          <div>
                            Panel is required**
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-md-4 dataupdateMultiselect">
                    <label>Language selection for providers</label>
                    <div>
                      <p-multiSelect [options]="providerLanguageOptions" defaultLabel="Select" maxSelectedLabels="1"
                        appendTo="body" placeholder="Select" [(ngModel)]="selectedProviderLanguageOptions"
                      formControlName="provierLanguageFormControl"></p-multiSelect>
                    </div>
                  </div>
                </div>
                <div class="row col-md-12" style="margin-top:20px">
                  <div class="col-md-4 dataupdateMultiselect">
                    <label>Language selection for provider staff</label>
                    <div>
                      <p-multiSelect [options]="staffLanguageOptions" defaultLabel="Select" maxSelectedLabels="1"
                        appendTo="body" placeholder="Select" [(ngModel)]="staffProviderLanguageOptions"
                      formControlName="staffLanguageFormControl"></p-multiSelect>
                    </div>
                  </div>
                  <div class="col-md-4 dataupdateMultiselect">
                    <label>Area of expertise(AOE)</label>
                    <div>
                      <p-multiSelect [options]="aoeOptions" defaultLabel="Select" maxSelectedLabels="1" appendTo="body"
                        placeholder="Select" [(ngModel)]="selectedAOEOptions"
                      formControlName="aoeFormControl"></p-multiSelect>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label><span class="red-star">*</span>Tax Id</label>
                    <input type="text" maxlength="10" placeholder="Enter Tax Id" formControlName="taxidFormControl" required (input)="onTaxIdInput($event)" class="form-control datePadding">
                    @if (submitted && dataUpdateForm.controls.taxidFormControl.invalid) {
                      <div
                        class="red-star">
                        @if (dataUpdateForm.controls.taxidFormControl.errors.required) {
                          <div>
                            Tax Id is required**
                          </div>
                        }
                        @if (dataUpdateForm.controls.taxidFormControl.errors.maxlength) {
                          <div>
                            Max Length of Tax Id is 9 digit**
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div>
                <div class="row col-md-12" style="margin-top:30px">
                  <h2>Address / Contact Details</h2> <br>
                </div>
                <div class="row col-md-12" style="margin-top:20px">
                  <div class="col-md-4">
                    <label>Street</label>
                    <input type="text" placeholder="Enter Street" formControlName="streetFormControl" class="form-control datePadding">
                  </div>
                  <div class="col-md-4">
                    <label>Suite</label>
                    <input type="text" placeholder="Enter Suite" formControlName="suiteFormControl" class="form-control datePadding">
                  </div>
                  <div class="col-md-4">
                    <label>City</label>
                    <input type="text" placeholder="Enter City" formControlName="cityFormControl" class="form-control datePadding">
                  </div>
                </div>
                <div class="row col-md-12" style="margin-top:20px">
                  <div class="col-md-4">
                    <label>State</label>
                    <input type="text" placeholder="Enter State" formControlName="stateFormControl" class="form-control datePadding">
                  </div>
                  <div class="col-md-4">
                    <label>Zipcode</label>
                    <!-- <input maxlength="10" (keyup)="onPhoneKeyUp1($event)" (keypress)="decimalRestrict($event)"
                    formControlName="zipCodeControl" type="text" class="form-control datePadding"> -->
                    <input maxlength="5" placeholder="Enter Zipcode" formControlName="zipCodeControl" type="text" (input)="onZipCodeInput($event)" class="form-control datePadding">
                  </div>
                  <div class="col-md-4">
                    <label>Phone Number</label>
                    <input maxlength="14" placeholder="Enter Phone Number" (keyup)="onPhoneKeyUp($event)" (keypress)="decimalRestrict($event)"
                      formControlName="phoneFormControl" type="text" class="form-control datePadding">
                    </div>
                  </div>
                  <div class="row col-md-12" style="margin-top:20px">
                    <div class="col-md-4">
                      <label>Fax</label>
                      <input maxlength="14" placeholder="Enter Fax" (keyup)="onPhoneKeyUp($event)" (keypress)="decimalRestrict($event)"
                        formControlName="faxFormControl" type="text" class="form-control datePadding">
                      </div>
                      <div class="col-md-4">
                        <label>Is a former address available?</label>
                        <select formControlName="formerAddressFormControl" type="text" class="form-select">
                          <option value="" selected>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                      </div>
                      <div class="col-md-3">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-12" style="margin-top:40px">
                    <h2>Office hours</h2> <br>
                    <h4>Please, add your available office hours by :</h4>
                  </div>
                  <div class="row col-md-12" style="margin-top:20px" formArrayName="timecheck">
                    <div class="row">
                      <div class="col-md-10">
                        <input type="radio" name="data-toggle" (change)="toggleValueEvent($event)" value="daily" style="font-size: 22px;" class="carelon-color" checked>
                        Add Daily
                        <input type="radio" name="data-toggle" (change)="toggleValueEvent($event)" class="carelon-color" value="weekly" style="margin-left: 10px; font-size: 22px;">
                        Add Weekly (Mon-Fri)
                      </div>
                      <div class="col-md-2" align="end">
                        <button type="button" (click)="addTime()" class="carelon-secondary-btn buttonInfo" style="margin: 0;">Add TimeSlots</button>
                      </div>
                    </div>
                    @if (officeHours) {
                      <div>
                        @for (skill of timecheck.controls; track skill; let i = $index) {
                          <div>
                            <div [formGroupName]="i">
                              <div class="rowMargin">
                                <div class="row" style="margin-bottom: 16px;">
                                  <b>TimeSlot : {{ i+1}}</b>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <label>Day:</label>
                                    <select type="text" class="form-select" formControlName="daySelectControl"
                                      (change)="onSelectionDay($event,i)">
                                      <option value="" selected>Select</option>
                                      <option>Monday</option>
                                      <option>Tuesday</option>
                                      <option>Wednesday</option>
                                      <option>Thursday</option>
                                      <option>Friday</option>
                                      <option>Saturday</option>
                                      <option>Sunday</option>
                                    </select>
                                  </div>
                                  <div class="col-md-4">
                                    <label>Start time:</label>
                                    <input type="time" class="form-control datePadding" formControlName="startTimeControl"
                                      (change)="onSelectionStartTime($event,i)">
                                    </div>
                                    <div class="col-md-3">
                                      <label>End time:</label>
                                      <input type="time" class="form-control datePadding" formControlName="endTimeControl"
                                        (change)="onSelectionEndTime($event,i)">
                                      </div>
                                      <div class="col-md-1">
                                        <button (click)="removeTime(i)" class="buttonInfo removebtn" style="background: none;">
                                          <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <title>Delete</title>
                                            <g id="New-Demo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                              <g id="00003-copy" transform="translate(-1181, -1467)" stroke="#FF0000">
                                                <g id="Delete" transform="translate(1181, 1467)">
                                                  <circle id="Oval" stroke-width="0.5" fill="#FFF8F8" cx="16" cy="16" r="15.75">
                                                  </circle>
                                                  <g id="icon_close-copy-6" transform="translate(9.7678, 9.7678)"
                                                    stroke-linecap="square">
                                                    <line x1="6.23215131" y1="-2.08144159" x2="6.23215131" y2="14.5457442" id="Line"
                                                      transform="translate(6.2322, 6.2322) rotate(-45) translate(-6.2322, -6.2322)">
                                                    </line>
                                                    <line x1="6.23215131" y1="-2.08144159" x2="6.23215131" y2="14.5457442" id="Line"
                                                      transform="translate(6.2322, 6.2322) scale(-1, 1) rotate(-45) translate(-6.2322, -6.2322)">
                                                    </line>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (!officeHours) {
                          <div>
                            @for (skill of timecheck.controls; track skill; let i = $index) {
                              <div>
                                <div [formGroupName]="i">
                                  <div class="rowMargin">
                                    <div class="row" style="margin-bottom: 16px;">
                                      <span style="font-weight: bold;">Weekly Time slots {{ i+1}} </span>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <label>Week:</label>
                                        <select type="text" class="form-select" formControlName="daySelectControl"
                                          (change)="onSelectionDay($event,i)">
                                          <option value="" selected>Select</option>
                                          <option>Monday-Friday</option>
                                          <option>Saturday</option>
                                          <option>Sunday</option>
                                        </select>
                                      </div>
                                      <div class="col-md-4">
                                        <label>Start time:</label>
                                        <input type="time" class="form-control datePadding" formControlName="startTimeControl"
                                          (change)="onSelectionStartTime($event,i)">
                                        </div>
                                        <div class="col-md-3">
                                          <label>End time:</label>
                                          <input type="time" class="form-control datePadding" formControlName="endTimeControl"
                                            (change)="onSelectionEndTime($event,i)">
                                          </div>
                                          <div class="col-md-1">
                                            <button (click)="removeTime(i)" class="buttonInfo removebtn" style="background: none;">
                                              <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <title>Delete</title>
                                                <g id="New-Demo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                  <g id="00003-copy" transform="translate(-1181, -1467)" stroke="#FF0000">
                                                    <g id="Delete" transform="translate(1181, 1467)">
                                                      <circle id="Oval" stroke-width="0.5" fill="#FFF8F8" cx="16" cy="16" r="15.75">
                                                      </circle>
                                                      <g id="icon_close-copy-6" transform="translate(9.7678, 9.7678)"
                                                        stroke-linecap="square">
                                                        <line x1="6.23215131" y1="-2.08144159" x2="6.23215131" y2="14.5457442" id="Line"
                                                          transform="translate(6.2322, 6.2322) rotate(-45) translate(-6.2322, -6.2322)">
                                                        </line>
                                                        <line x1="6.23215131" y1="-2.08144159" x2="6.23215131" y2="14.5457442" id="Line"
                                                          transform="translate(6.2322, 6.2322) scale(-1, 1) rotate(-45) translate(-6.2322, -6.2322)">
                                                        </line>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            <div class="col-md-3">
                            </div>
                          </div>
                          <div class="row col-md-12" style="margin-top:20px">
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3">
                            </div>
                          </div>
                          <div class="row col-md-12" style="margin-top:20px">
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3">
                            </div>
                          </div>
                          <div class="modal-footer">
                            <div class="container-contact100-form-btn" style="float: right;">
                              <button type="button" (click)="clearForm()" class="carelon-secondary-btn buttonInfo"
                              style="margin-top: 20px;">Clear</button>
                              <button type="submit" class="carelon-primary-btn buttonInfo">Submit</button>
                            </div>
                          </div>
                          <div style="padding: 20px;">
                          </div>
                        </div>
                      </form>
                    </div>
                  } @else {
                    <!-- <app-pdm-data-old></app-pdm-data-old> -->
                    <app-provider-outreach></app-provider-outreach>
                  }
                </div>
              </div>
            </div>
            <div class="modal fade " data-backdrop="true" id="apierrorModal" role="dialog" style="margin-top: 10%;">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header" style="background-color:#337ab7">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="modal-body">
                    <p style="text-align:center;">Some error occured !.Please try again later</p>
                  </div>
                  <div class="modal-footer">
                    <div class="container-contact100-form-btn">
                      <button type="button" class="btn btn-primary buttonInfo" data-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <app-footer></app-footer>
